import React from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  Container,
  Stack,
} from "@mui/material";
// import "../../setorku/_setorku.scss";
import DataTable from "presentation/components/DataTable";
import LayoutComponent from "presentation/layout/Layout";
import useDanaHistoryTransactionViewModel from "./DanaTransactionHistoryViewModel";
import FilterModal from "./components/FilterModal";
import RefundModal from "./components/RefundModal";


const DanaHistoryTransactionComponent = () => {
  const {
    data,
    modal,
    modalHandler,
    submitRefund,
    handleSubmit,
    control,
    page,
    setPage,
    pageSize,
    setPageSize,
    startDate,
    endDate,
    setStartdate,
    setEndate,
    columns,
    t,
  } = useDanaHistoryTransactionViewModel();

  return (
    <LayoutComponent>
      <Container
        maxWidth={false}
        sx={{ height: "100vh", backgroundColor: { xs: "#fff", md: "#f4f4f4" } }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            paddingTop: "2rem",
          }}
        >
          <Box
            sx={{
              width: "95%",
              backgroundColor: "white",
              boxShadow: "0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
              borderRadius: "8px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "rgba(34, 136, 102, 0.12)",
              },
            }}
          >
            <Grid
              container
              sx={{
                boxShadow: { sm: "0 0 5px #ddd" },
                padding: "1rem",
              }}
            >
              <Stack
                spacing={2}
                direction="row"
                className="headerSetorku"
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  className="headerName"
                  variant="h6"
                  component="h1"
                  sx={{
                    mb: "1.5rem",
                    fontWeight: 600,
                  }}
                >
                  {t("dana.transaction_history.title")}
                </Typography>

                <Stack spacing={2} direction="row" className="headerButton">
                  <div>
                    <Button
                      variant="outlined"
                      sx={{
                        height: "42px",
                        color: "rgba(34, 136, 102, 0.5)",
                        borderColor: "rgba(34, 136, 102, 0.5) !important",
                      }}
                      onClick={() => modalHandler("filter")}
                    >
                      {t("dana.transaction_history.filter_button")}
                    </Button>
                  </div>
                  <Button
                    // onClick={onExpor}
                    variant="contained"
                    sx={{
                      height: "42px",
                      borderColor: "rgba(34, 136, 102, 0.5)",
                      color: "#FFFFFF",
                      backgroundColor: "rgba(40, 99, 83, 1) !important",
                      shadows: "rgba(0, 0, 0, 0.12)",
                    }}
                  >
                    {t("dana.transaction_history.export_button")}
                  </Button>
                </Stack>
              </Stack>

              <DataTable
                {...{
                  data: data.transactionHistory.data.data,
                  totalRows: data.transactionHistory.data.totalRows,
                  columns,
                  setPage,
                  setPageSize,
                  page,
                  pageSize,
                }}
              />
            </Grid>
          </Box>
        </div>

        <FilterModal
          header={t("dana.transaction_history.modal_filter_header")}
          subHeader={t("dana.transaction_history.modal_filter_sub_header")}
          open={modal.filter}
          onClose={() => modalHandler('filter')}
          applyButton={() => modalHandler('filter')}
          cancelButton={() => modalHandler('filter')}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartdate}
          setEndDate={setEndate}
        />

        <RefundModal open={modal.refund} onClose={() => modalHandler('refund')} control={control} applyButton={handleSubmit(submitRefund)}/>
      </Container>
    </LayoutComponent>
  );
};

export default DanaHistoryTransactionComponent;